import { Injectable } from '@angular/core';
import { Config } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripeLoaderService {

  private stripePromise: Promise<any> | null = null;

  loadStripe(): Promise<any> {
    if (this.stripePromise) {
      return this.stripePromise;
    }

    if ((window as any).Stripe) {
      this.stripePromise = Promise.resolve((window as any).Stripe(Config.STRIPE_PUBLISHABLE_KEY));
      return this.stripePromise;
    }

    this.stripePromise = new Promise((resolve, reject) => {
      let script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.onload = () => {
        resolve((window as any).Stripe(Config.STRIPE_PUBLISHABLE_KEY));
      };
      script.onerror = () => {
        this.stripePromise = null;
        reject(new Error('Failed to load Stripe.js'));
      };
      document.getElementsByTagName('head')[0].appendChild(script);
    });

    return this.stripePromise;
  }
}
